import React from 'react';

import './index.css';


const getText = () => (
  <div styleName="textContainer">
    My IPO sign up is free and there are no associated membership fees to maintain an
    account. You are not charged any fees when you purchase offers and invest. For publicly
    traded securities there is a $10 trade fee charged should you buy shares in the open market
    (outside of an offering) or sell shares in the future, plus we pass along regulatory fees
    such as SEC and TAF fees as part of the “Commission/Service Fees”. The SEC and TAF fees or
    “Service Fees” are very minimal charges.
    <br />
    <br />
    For non-public securities there may be no liquidity, limited liquidity and redemption fees
    may apply if redeemed before maturity as outlined in each offering prospectus.
    <br />
    <br />
    The SEC and FINRA Trading Activity Fee (TAF) are regulatory fees charged on the sale of any
    security. These fees are automatically debited from the proceeds of any security sale. These
    minor fees only occur on the sale of a security and are equal to:
    <br />
    <br />
    &#8208;&nbsp;SEC Fee&nbsp;&#61;&nbsp;total price of transaction times 0.000013
    <br />
    &#8208;&nbsp;TAF&nbsp;&#61;&nbsp;number of shares sold times $0.000119 with a maximum
    of $5.95
    <br />
    <br />
    Both fees are rounded up to the nearest penny.
  </div>
);

export default getText;



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/DisclaimerViews/ServiceFeeText.js